import Vue from 'vue';
import Router from 'vue-router';
import Meta from 'vue-meta';
import Home from '@/components/views/Home';
import NotFound from '@/components/views/NotFound';
import Contact from '@/components/views/Contact';
import About from '@/components/views/About';
import Privacy from '@/components/views/Privacy';
import Terms from '@/components/views/Terms';
import Login from '@/components/views/Login';
import Register from '@/components/views/Register';
import RegisterOk from '@/components/views/RegisterOk';
import RegisterArtistOk from '@/components/views/RegisterArtistOk';
import ArtistRegister from '@/components/views/ArtistRegister';
import Gallery from '@/components/views/Gallery';
import Love from '@/components/views/Love';
import Artists from '@/components/views/Artists';
import Piece from '@/components/views/Piece';
// Account
import Account from '@/components/views/Account';
import AccountProfile from '@/components/views/AccountProfile';
import AccountAddress from '@/components/views/AccountAddress';
import AccountRentals from '@/components/views/AccountRentals';
import AccountOrders from '@/components/views/AccountOrders';
import Order from '@/components/views/Order';
import OrderOk from '@/components/views/OrderOk';
import ContactOk from '@/components/views/ContactOk';
import KeepOkay from '@/components/views/KeepOkay';
import OrderNotOk from '@/components/views/OrderNotOk';
import ConfirmEmail from '@/components/views/ConfirmEmail';
import Rental from '@/components/views/Rental';
import Checkout from '@/components/views/Checkout';
import Cart from '@/components/views/Cart';
import Rent from '@/components/views/Rent';
import PaymentSuccess from '@/components/views/PaymentSuccess';
import PaymentFailed from '@/components/views/PaymentFailed';
import ResetPassword from '@/components/views/ResetPassword';
// Help
import Help from '@/components/views/Help';
import HelpPackaging from '@/components/views/articles/Packaging';
import Rentals from '@/components/views/Rentals';
import Consulting from '@/components/views/Consulting';
// Legal
import Legal from '@/components/views/Legal';

import store from '@/store';

Vue.use(Router);
Vue.use(Meta);

const router = new Router({
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        title: 'Home',
        layout: 'layout-hero',
      },
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        title: 'Login',
        layout: 'layout-app',
      },
    },
    {
      path: '/register',
      name: 'register',
      component: Register,
      meta: { layout: 'layout-app' },
    },
    {
      path: '/register-ok',
      name: 'RegisterOk',
      component: RegisterOk,
      meta: { layout: 'layout-basic' },
    },
    {
      path: '/register-artist-ok',
      name: 'RegisterArtistOk',
      component: RegisterArtistOk,
      meta: { layout: 'layout-basic' },
    },
    {
      path: '/artist-register',
      name: 'artist-register',
      component: ArtistRegister,
      meta: { layout: 'layout-app' },
    },
    {
      path: '/reset-password',
      name: 'ResetPassword',
      component: ResetPassword,
      meta: { layout: 'layout-basic' },
    },
    {
      path: '/account',
      component: Account,
      meta: {
        layout: 'layout-basic',
        authRequired: true,
      },
      children: [
        {
          path: 'profile',
          name: 'AccountProfile',
          component: AccountProfile,
          meta: {
            layout: 'layout-basic',
            authRequired: true,
          },
        },
        {
          path: 'address',
          name: 'AccountAddress',
          component: AccountAddress,
          meta: {
            layout: 'layout-basic',
            authRequired: true,
          },
        },
        {
          path: 'orders',
          name: 'AccountOrders',
          component: AccountOrders,
          meta: {
            layout: 'layout-basic',
            authRequired: true,
          },
        },
        {
          path: 'rentals',
          name: 'AccountRentals',
          component: AccountRentals,
          meta: {
            layout: 'layout-basic',
            authRequired: true,
          },
        },
      ],
    },
    {
      path: '/cart',
      name: 'cart',
      component: Cart,
      meta: { layout: 'layout-basic', authRequired: true },
    },
    {
      path: '/rent',
      name: 'rent',
      component: Rent,
      meta: {
        layout: 'layout-basic',
        authRequired: true,
      },
    },
    {
      path: '/checkout/:type',
      name: 'checkout',
      component: Checkout,
      meta: {
        layout: 'layout-app',
        authRequired: true,
      },
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact,
      meta: { layout: 'layout-basic' },
    },
    {
      path: '/about',
      name: 'about',
      component: About,
      meta: { layout: 'layout-hero' },
    },
    {
      path: '/help',
      name: 'help',
      component: Help,
      meta: { layout: 'layout-basic' },
    },
    {
      path: '/legal',
      name: 'legal',
      component: Legal,
      meta: { layout: 'layout-basic' },
    },
    {
      path: '/help/packaging',
      name: 'HelpPackaging',
      component: HelpPackaging,
      meta: { layout: 'layout-basic' },
    },
    {
      path: '/rentals',
      name: 'rentals',
      component: Rentals,
      meta: { layout: 'layout-basic' },
    },
    {
      path: '/consulting',
      name: 'consulting',
      component: Consulting,
      meta: { layout: 'layout-hero' },
    },
    {
      // path: '/gallery/:form?/:medium?/:style?/:subject?/:artist_id?',
      path: '/gallery',
      name: 'gallery',
      component: Gallery,
      meta: {
        layout: 'layout-basic',
        title: 'Art Gallery',
      },
    },
    {
      path: '/love',
      name: 'love',
      component: Love,
      meta: { layout: 'layout-basic' },
    },
    {
      path: '/artists',
      name: 'artists',
      component: Artists,
      meta: { layout: 'layout-basic' },
    },
    {
      path: '/art/:pieceId/:pieceTitle',
      name: 'Piece',
      component: Piece,
      meta: {
        layout: 'layout-basic',
      },
    },
    {
      path: '/account/orders/:orderId',
      name: 'order',
      component: Order,
      meta: {
        layout: 'layout-basic',
        authRequired: true,
      },
    },
    {
      path: '/account/rentals/:rentalId',
      name: 'rental',
      component: Rental,
      meta: {
        layout: 'layout-basic',
        authRequired: true,
      },
    },
    // {
    //   path: '/gallery/:pieceTitle',
    //   name: 'Piece',
    //   component: Piece,
    //   props: route => ({
    //     // user: userData,
    //     ...route.params,
    //   }),
    //   meta: {
    //     layout: 'layout-basic',
    //   },
    // },
    {
      path: '/order-ok',
      name: 'OrderOk',
      component: OrderOk,
      meta: { layout: 'layout-basic' },
    },
    {
      path: '/contact-ok',
      name: 'ContactOk',
      component: ContactOk,
      meta: { layout: 'layout-basic' },
    },
    {
      path: '/keep-ok',
      name: 'KeepOkay',
      component: KeepOkay,
      meta: { layout: 'layout-basic' },
    },
    {
      path: '/confirm-email',
      name: 'ConfirmEmail',
      component: ConfirmEmail,
      meta: { layout: 'layout-basic' },
    },
    {
      path: '/order-not-ok',
      name: 'OrderNotOk',
      component: OrderNotOk,
      meta: { layout: 'layout-basic' },
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: Privacy,
      meta: { layout: 'layout-basic' },
    },
    {
      path: '/terms',
      name: 'terms',
      component: Terms,
      meta: { layout: 'layout-basic' },
    },
    {
      path: '*',
      name: 'notfound',
      component: NotFound,
      meta: { layout: 'layout-basic' },
    },
    {
      path: '/payment-success',
      name: 'paymentsuccess',
      component: PaymentSuccess,
    },
    {
      path: '/payment-failed',
      name: 'paymentfailed',
      component: PaymentFailed,
    },
  ],
});

// eslint-disable-next-line consistent-return
router.beforeEach((to, from, next) => {
  if (from.name !== 'login') {
    store.commit('account/setFromUrl', from.path);
  }
  // Set view layout
  store.commit('layout/setLayout', to.meta.layout);
  // redirect to login page if not logged in and trying to access a restricted page
  const authRequired = to.matched.some(record => record.meta.authRequired);
  const loggedIn = localStorage.getItem('user');

  if (!loggedIn && authRequired) {
    // Save url user was going to, to continue there after login
    store.commit('account/setToUrl', to.path);
    return next('/login');
  }
  // Set page title
  document.title = to.name;
  next();
});


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js